import type { TFindInvalid, TValueCalculator } from '../models';

export const calculateProgress: TValueCalculator = (form, initValue = 0) => {
    const state = form.getState();
    const allFields = form.getRegisteredFields();
    const successFields = allFields.filter(value => {
        if (!state.errors[value] && state.values[value]) return true;

        return false;
    });
    const calculateValue = (acc: number, cField: string): number =>
        acc + (form.getFieldState(cField)?.data?.progressBarValue || /* istanbul ignore next */ 0);

    const value = successFields.reduce(calculateValue, 0);

    return initValue + value;
};

export const findInvalid: TFindInvalid = (errors, form) =>
    form
        .getRegisteredFields()
        .find(
            field =>
                errors[field] !== undefined && form.getFieldState(field)?.data?.progressBarValue
        ) ?? '';
